import { render, staticRenderFns } from "./AppNewsModal.vue?vue&type=template&id=22bd5549&scoped=true"
import script from "./AppNewsModal.vue?vue&type=script&lang=js"
export * from "./AppNewsModal.vue?vue&type=script&lang=js"
import style0 from "./AppNewsModal.vue?vue&type=style&index=0&id=22bd5549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd5549",
  null
  
)

export default component.exports